import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import { RidesCalendarWrapper } from "../pages/sections/RidesCalendarWrapper";
import { ClientsPage } from "app/pages/sections/ClientsPage";
import { ReferentsPage } from 'app/pages/sections/ReferentsPage'
import { ProvidersPage } from 'app/pages/sections/ProvidersPage'
import { MeansPage } from 'app/pages/sections/MeansPage'
import { DriversPage } from 'app/pages/sections/DriversPage'
import {RidesPage} from "../pages/sections/RidesPage";
import {ServicesPage} from "../pages/sections/ServicesPage";
import { DriversCalendarWrapper } from 'app/pages/sections/DriversCalendarWrapper'
import { MeansCalendarWrapper } from 'app/pages/sections/MeansCalendarWrapper'

const PrivateRoutes = () => {
    const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'));
    const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'));
    const AccountPage = lazy(() => import('../modules/accounts/AccountPage'));
    const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'));
    const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'));
    const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'));

    return (
        <Routes>
            <Route element={<MasterLayout />}>
                {/* Redirect to Dashboard after success login/registartion */}
                <Route path='auth/*' element={<Navigate to='/services' />} />
                {/* Pages */}
                <Route path='clients' element={<ClientsPage />} />
                <Route path='dashboard' element={<DashboardWrapper />} />
                <Route path='drivers' element={<DriversPage />} />
                <Route path='means' element={<MeansPage />} />
                <Route path='providers' element={<ProvidersPage />} />
                <Route path='referents' element={<ReferentsPage />} />
                <Route path='rides' element={<RidesPage />} />
                <Route path='calendar-rides' element={<RidesCalendarWrapper />} />
                <Route path='calendar-drivers' element={<DriversCalendarWrapper />} />
                <Route path='calendar-means' element={<MeansCalendarWrapper />} />
                <Route path='services' element={<ServicesPage />} />
                {/* Lazy Modules */}
                <Route
                    path='crafted/pages/profile/*'
                    element={
                        <SuspensedView>
                            <ProfilePage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='crafted/pages/wizards/*'
                    element={
                        <SuspensedView>
                            <WizardsPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='crafted/widgets/*'
                    element={
                        <SuspensedView>
                            <WidgetsPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='crafted/account/*'
                    element={
                        <SuspensedView>
                            <AccountPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='apps/chat/*'
                    element={
                        <SuspensedView>
                            <ChatPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='apps/user-management/*'
                    element={
                        <SuspensedView>
                            <UsersPage />
                        </SuspensedView>
                    }
                />
                {/* Page Not Found */}
                <Route path='*' element={<Navigate to='/error/404' />} />
            </Route>
        </Routes>
    )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
    const baseColor = getCSSVariableValue('--bs-primary')
    TopBarProgress.config({
        barColors: {
            '0': baseColor,
        },
        barThickness: 1,
        shadowBlur: 5,
    })
    return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
